
import React, { Fragment, useState, useEffect, useMemo } from 'react';
import IndicatorsForecastDetailsTable from './IndicatorsForecastDetailsTable';
import { useReportData, useUpdateResult, useNewResult } from 'shared/apollo';
import { LinearProgress } from '@mui/material';
import styled from 'styled-components';
import { getResults, OPT_CLASS_LEARN, OPT_CLASS_ACT, OPT_CLASS_SOCIAL, OPT_CLASS_REACH, OPT_CLASS_CAPACITY } from './constants';


const Table = ({ reportId, beneficiary }) => {
  /* state */
  const [selectedIndicators, setSelectedIndicators] = useState([]);

  /* graphql */
  const withResults = true;
  const { data: report, loading: loadingReport, refetch: reloadReport } = useReportData(reportId, withResults);
  const { run: runNew, isLoading: loadingNew } = useNewResult();
  const { run: runUpdate, isLoading: loadingUpdate } = useUpdateResult();

  /* effects */
  useEffect(() => {
    setSelectedIndicators(report?.indicators??[]);
  }, [report]);

  /* actions */
  const handleSaveOrUpdate = (data) => {
    if (data&&reportId) {
      const form = {...data, reportId};
      if (form.id) {
        runUpdate(form, () => {reloadReport();});
      } else {
        runNew(form, () => {reloadReport();});
      }
    }
  };

  /* constants memo */ 
  const indicatorsByStage = useMemo(() => {
    return getResults(report, selectedIndicators);
  }, [report, selectedIndicators]);

  const isLoading = useMemo(() => {
    return (loadingReport||loadingNew||loadingUpdate);
  }, [loadingReport, loadingNew, loadingUpdate]);

  return <Fragment>
    <Progress display={isLoading} />
    <IndicatorsForecastDetailsTable 
      stageName="Capacity Development"
      indicators={indicatorsByStage[6]}
      handleSaveOrUpdate={handleSaveOrUpdate}
      beneficiary={beneficiary}
      classificationOpts={OPT_CLASS_CAPACITY}
      isLoading={isLoading}
    />
    <IndicatorsForecastDetailsTable
      stageName="Reach"
      indicators={indicatorsByStage[5]}
      handleSaveOrUpdate={handleSaveOrUpdate}
      beneficiary={beneficiary}
      classificationOpts={OPT_CLASS_REACH}
      isLoading={isLoading}
    />
    <IndicatorsForecastDetailsTable
      stageName="Learn"
      indicators={indicatorsByStage[1]}
      handleSaveOrUpdate={handleSaveOrUpdate}
      beneficiary={beneficiary}
      classificationOpts={OPT_CLASS_LEARN}
      isLoading={isLoading}
    />
    <IndicatorsForecastDetailsTable
      stageName="Act"
      indicators={indicatorsByStage[2]}
      handleSaveOrUpdate={handleSaveOrUpdate}
      beneficiary={beneficiary}
      classificationOpts={OPT_CLASS_ACT}
      isLoading={isLoading}
    />
    <IndicatorsForecastDetailsTable
      stageName="Succeed (Social Impact)"
      indicators={indicatorsByStage[3]}
      handleSaveOrUpdate={handleSaveOrUpdate}
      beneficiary={beneficiary}
      classificationOpts={OPT_CLASS_SOCIAL}
      isLoading={isLoading}
    />
  </Fragment>;
};

export default Table;

const Progress = styled(LinearProgress)`
  transition: width 0.3s ease-out;
  position: absolute !important;
  background-color: #0072A2 !important;
  width: ${props => props.display ? '100%' : '0%'};
  top: 0px;
  left: 0px;
  .MuiLinearProgress-barColorPrimary {
    background-color: #bccdd1 !important;
  }
`;
